module.exports = __webpack_public_path__ + "img/grid_orange.34761b04.png";